import React, { Component } from "react";
import { LinearProgress } from "reactackle";
import { connect } from "react-redux";
import { compose } from "recompose";
import {
  setUiFlag,
  reachApi,
  getStatement,
  getStatementB64,
  notifyUsers,
  actionAddArray2Redux
} from "../../../../store/actions";
import { withFirebase } from "../../Firebase";
import { isMobile } from "react-device-detect";
import { TextField, Button, CircleProgress } from "reactackle";
import moment from "moment";
import { addAudit } from "../audits/addAudits";
import PhotoUploadPass from "../FieldsComponents/PhotoUpload/PhotoUploadPass";
import SignPad from "../FieldsComponents/SignPad/SignPad";
import { mrpPmtImage } from "./mrpPmtImage";

class BgdPassportServiceExt extends Component {
  state = {
    data: {
      path: "myPassApplication",
      payload: {
        textName: "",
        textNameBangla: "",
        emailId: "",
        phoneNumber: this.props.cellPhone,
        passportNumber: "",
        dateOfIssue: "",
        dateOfExpiry: "",
        placeOfIssue: "",
        dateOfBirth: "",
        infoExist1: "",
        expectedChange1: "",
        infoExist2: "",
        expectedChange2: "",
        infoExist3: "",
        expectedChange3: "",
        infoExist4: "",
        expectedChange4: "",
        wpBack: [],
        wpFront: [],
        passportImages: [],
        ...this.props.db["myPassDetails"]
      }
    },

    reloadDone: false,
    generatingStatement: false,
    statementLink: "",
    b64Text: "",
    stage: "home",
    sgPresence: ""
  };

  componentDidMount() {
    if (window.location.hostname === "localhost") {
      this.setState({
        data: {
          path: "myPassApplication",
          payload: {
            textName: "name english",
            textNameBangla: "name bangla",
            emailId: "ahmed_fayyaz@outlook.com",
            phoneNumber: this.props.cellPhone,
            passportNumber: "p123456",
            dateOfIssue: "10 JAN 1998",
            dateOfExpiry: "10 DEC 2003",
            placeOfIssue: "DHKA",
            dateOfBirth: "10 FEB 1990",
            infoExist1: "A",
            expectedChange1: "AA",
            infoExist2: "B",
            expectedChange2: "BB",
            infoExist3: "C",
            expectedChange3: "CC",
            infoExist4: "D",
            expectedChange4: "DD",
            wpBack: [],
            wpFront: [],
            passportImages: []
          }
        },
        reloadDone: false,
        generatingStatement: false,
        statementLink: ""
        // reloadDone: true,
        // generatingStatement: false,
        // statementLink:
        //   "https://us1.pdfgeneratorapi.com/share/6667/7c075ba68344cee7a11cf6a33f2f811b",
        // b64Text: "",
        // stage: "inputPayment",
        // sgPresence: "YES",
        // sgDocs: "YES",
        // sigB64:
        //   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLwAAAHCCAYAAADlz9AsAAAgAElEQVR4XuzdCbRmRXno/X/duz7jDCqOgKAoohCGgAOKgY6IQQFFQ9+ocUATMI6giCa5dwH3ZomKERHFQIwQBW9CB0VQnEMbJQiKDBEQB0AFHHBANBpjcutbz3veVsQ+766932kP/1qrVwOnqvZTv9rdh/c5NSQsCiiggAIKKKCAAgoooIACCiiggAIK9Egg9WgsDkUBBRRQQAEFFFBAAQUUUEABBRRQQAFMePkSKKCAAgoooIACCiiggAIKKKCAAgr0SsCEV6+m08EooIACCiiggAIKKKCAAgoooIACCpjw8h1QQAEFFFBAAQUUUEABBRRQQAEFFOiVgAmvXk2ng1FAAQUUUEABBRRQQAEFFFBAAQUUMOHlO6CAAgoooIACCiiggAIKKKCAAgoo0CsBE169mk4Ho4ACCiiggAIKKKCAAg...",
        // passportImages: [
        //   '{b64: "data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQ…}'
        // ],
        // wpFront: ['{b64: "data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQ…}'],
        // wpBack: ['{b64: "data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQ…}'],
        // generatingManualPDF: false
      });
    }
    if (
      this.props.db["myPassApplication"] &&
      Object.keys(this.props.db["myPassApplication"]).length > 0
    ) {
      this.setState(this.props.db["myPassApplication"]);
    }
  }

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(
        prevState => {
          if (prevState && prevState.data.payload !== null) {
            return {
              ...prevState,
              data: {
                ...prevState.data,
                payload: {
                  ...prevState.data.payload,
                  ...tmpState
                }
              }
            };
          } else {
            return {
              ...prevState,
              data: {
                path: prevState.data.path,
                payload: {
                  ...tmpState
                }
              }
            };
          }
        },
        () => {
          this.props.onAddRecord({
            path: "myPassApplication",
            payload: this.state
          });
        }
      );
    } else {
      this.setState(
        prevState => {
          return {
            ...prevState,
            ...tmpState
          };
        },
        () => {
          this.props.onAddRecord({
            path: "myPassApplication",
            payload: this.state
          });
        }
      );
    }
  };

  openPdfInAppBrowser = () => {
    let msgToApp = {
      actionType: "openPdf",
      payload: {
        url: this.state.statementLink
      }
    };

    if (window && window.ReactNativeWebView) {
      //console.log("posing autologin message to app");
      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
    }
  };

  getStatementLoader = () => {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "30px"
        }}
      >
        <CircleProgress
          indeterminate
          circleSize={80}
          strokeSize={10}
          labelPositionY="bottom"
          labelPositionX="center"
        />
        <div style={{ fontSize: "20px", marginTop: "10px" }}>
          Submitting application... please be patient as it can take upto a
          minute <br />
          একটু অপেক্ষা করুন, ফরম ইমেইল হতে এক মিনিটের মতো লাগতে পারে।
        </div>
      </div>
    );
  };

  getManualPDFLoader = () => {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "30px"
        }}
      >
        <CircleProgress
          indeterminate
          circleSize={80}
          strokeSize={10}
          labelPositionY="bottom"
          labelPositionX="center"
        />
        <div style={{ fontSize: "20px", marginTop: "10px" }}>
          Generating PDF... please be patient as it can take upto a minute{" "}
          <br />
          একটু অপেক্ষা করুন, ফরম ইমেইল হতে এক মিনিটের মতো লাগতে পারে।
        </div>
      </div>
    );
  };

  getFormattedDate = (dtText, dtFormat) => {
    if (dtText) {
      dtText = dtText.trim();
    }
    if (dtText && dtText.length === 11) {
      let momDate = moment(dtText, "DD MMM YYYY").toString();
      if (momDate.includes("Invalid")) {
        return "Invalid Date";
      } else {
        let tgtDate = moment(dtText, "DD MMM YYYYY")
          .format(dtFormat)
          .toString();
        return tgtDate;
      }
    } else {
      if (dtText !== "") {
        return "Invalid Date";
      }
    }
  };

  getPaddedStrObj = (strText, fieldName) => {
    strText = strText.trim();
    let retObj = {};
    let ctr = 1;
    for (let i = 0; i < strText.length; i++) {
      retObj[fieldName + "" + ctr] = strText[i] + "";
      ctr = ctr + 1;
    }
    return retObj;
  };

  getPOData = () => {
    let statePoData = this.state.data.payload;
    let finalPoData = JSON.parse(JSON.stringify(statePoData));
    let issueDateObj = this.getPaddedStrObj(
      this.getFormattedDate(finalPoData.dateOfIssue, "DDMMYYYY"),
      "dateOfIssue"
    );
    let expiryDateObj = this.getPaddedStrObj(
      this.getFormattedDate(finalPoData.dateOfExpiry, "DDMMYYYY"),
      "dateOfExpiry"
    );
    let dateObj = this.getPaddedStrObj(
      moment()
        .format("DDMMYY")
        .toString(),
      "date"
    );
    let pNumberObj = this.getPaddedStrObj(
      finalPoData.passportNumber,
      "passportNumber"
    );
    let baseData = {
      nameEnglish: finalPoData.textName,
      nameBangla: finalPoData.textNameBangla,
      dob: finalPoData.dateOfBirth,
      ...pNumberObj,
      ...issueDateObj,
      ...expiryDateObj,
      placeOfIssue: finalPoData.placeOfIssue,
      mobileNumber: finalPoData.phoneNumber,
      emailAddress: finalPoData.emailId,
      banglaB64Text: finalPoData.banglaB64Text,
      infoExist1: finalPoData.infoExist1,
      expectedChange1: finalPoData.expectedChange1,
      infoExist2: finalPoData.infoExist2,
      expectedChange2: finalPoData.expectedChange2,
      infoExist3: finalPoData.infoExist3,
      expectedChange3: finalPoData.expectedChange3,
      infoExist4: finalPoData.infoExist4,
      expectedChange4: finalPoData.expectedChange4,
      passportImage:
        this.state.passportImages && this.state.passportImages[0]
          ? this.state.passportImages[0].b64
          : "",
      wpFront:
        this.state.wpFront && this.state.wpFront[0]
          ? this.state.wpFront[0].b64
          : "",
      wpBack:
        this.state.wpBack && this.state.wpBack[0]
          ? this.state.wpBack[0].b64
          : "",
      payPhoto:
        this.state.payPhoto && this.state.payPhoto[0]
          ? this.state.payPhoto[0].b64
          : "",
      sigB64: this.state.sigB64,
      ...dateObj
    };

    //console.log(JSON.stringify(finalPoData));
    return baseData;
  };

  getTemplateId = () => {
    let templateId = "131894";

    return templateId;
  };

  getEmailText = () => {
    let emTxt = "Dear Sir \n Please see attached my application";
    emTxt =
      emTxt +
      " for passport renewal(or updates) as per the following details: \n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n";
    emTxt =
      emTxt +
      "Applicant Name (English): " +
      this.state.data.payload.textName +
      " \n";
    emTxt =
      emTxt +
      "Applicant Name (Bangla): " +
      this.state.data.payload.textNameBangla +
      " \n";
    emTxt =
      emTxt + "Passport No.: " + this.state.data.payload.passportNumber + " \n";
    emTxt =
      emTxt + "Place of Issue: " + this.state.data.payload.placeOfIssue + " \n";
    emTxt =
      emTxt + "Date of Expiry: " + this.state.data.payload.dateOfExpiry + " \n";
    emTxt =
      emTxt + "Date of Issue: " + this.state.data.payload.dateOfIssue + " \n";
    emTxt =
      emTxt +
      "Date: " +
      moment()
        .format("DDMMYYYY")
        .toString() +
      " \n";
    emTxt = emTxt + "Mobile No: " + this.state.data.payload.phoneNumber + " \n";
    emTxt = emTxt + "Email Address: " + this.state.data.payload.emailId + " \n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "Expected Corrections (if any)" + " \n";
    emTxt =
      emTxt +
      this.state.data.payload.infoExist1 +
      "  :   " +
      this.state.data.payload.expectedChange1 +
      "   \n";
    emTxt =
      emTxt +
      this.state.data.payload.infoExist2 +
      "  :   " +
      this.state.data.payload.expectedChange2 +
      "   \n";
    emTxt =
      emTxt +
      this.state.data.payload.infoExist3 +
      "  :   " +
      this.state.data.payload.expectedChange3 +
      "   \n";
    emTxt =
      emTxt +
      this.state.data.payload.infoExist4 +
      "  :   " +
      this.state.data.payload.expectedChange4 +
      "   \n";

    emTxt = emTxt + "\n";
    emTxt =
      emTxt +
      "I have attached with this email the duly completed application form along with photocopies of following documents: \n";
    emTxt =
      emTxt +
      " - Passport \n - Work Permit (Front & Back) \n - Proof of payment \n";
    emTxt =
      emTxt +
      "For any further information please rechout to me at my phone number or email provided above.\n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n Note: \n";
    emTxt = emTxt + "";
    emTxt = emTxt + "- This is a system generated email. \n";
    emTxt =
      emTxt +
      " - Information provided above is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information. \n";
    emTxt =
      emTxt +
      "- For any further information please contact the applicant or Bangladesh High Commission directly \n";
    emTxt =
      emTxt +
      " - BCS App only generates the application form and sends an email application to the High Commission to facilitate workers and make it easier to send passport renewal application. For any further enquires on the renewal process / acceptance of application, users are responsible to contact Bangladesh High Commission directly. \n";
    emTxt =
      emTxt +
      " - Please note it is applicant's responsibility to contact the High Commission directly. This email is may not be enough for your applicaiton to be accepted as you might be required to visit High Commission in person. \n";

    emTxt = emTxt + "\n ";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n";
    return emTxt;
  };

  getHtmlRow = (heading, value) => {
    return (
      "<tr><td style='border: 1px solid black;padding: 5px'>" +
      heading +
      "</td><td style='border: 1px solid black;padding: 5px'>" +
      value +
      "</td></tr>"
    );
  };

  getRow = (heading, value) => {
    return (
      <tr>
        <td>{heading}</td>
        <td>{value}</td>
      </tr>
    );
  };

  getEmailHtml = () => {
    let emTxt = "<p>Dear Sir </p><p> Please see attached my application";
    emTxt = emTxt + " for passport renewal as per the following details: </p>";
    emTxt = emTxt + "<p></p>";
    emTxt =
      emTxt +
      "<table style='border: 1px solid black;max-width: 450px;min-width:450px'><tbody>";
    emTxt =
      emTxt +
      this.getHtmlRow(
        "Applicant Name (English)",
        this.state.data.payload.textName
      );
    emTxt =
      emTxt +
      this.getHtmlRow(
        "Applicant Name (Bangla)",
        this.state.data.payload.textNameBangla
      );
    emTxt =
      emTxt +
      this.getHtmlRow("Passport No.", this.state.data.payload.passportNumber);

    emTxt =
      emTxt +
      this.getHtmlRow("Place of Issue", this.state.data.payload.placeOfIssue);
    emTxt =
      emTxt +
      this.getHtmlRow("Date of Expiry", this.state.data.payload.dateOfExpiry);
    emTxt =
      emTxt +
      this.getHtmlRow("Date of Issue", this.state.data.payload.dateOfIssue);
    emTxt =
      emTxt +
      this.getHtmlRow(
        "Date",
        moment()
          .format("DD MMM YYYY")
          .toString()
      );
    emTxt =
      emTxt + this.getHtmlRow("Mobile No", this.state.data.payload.phoneNumber);

    emTxt =
      emTxt + this.getHtmlRow("Email Address", this.state.data.payload.emailId);
    emTxt = emTxt + "</tbody></table>";
    emTxt = emTxt + "<p></p><p></p>";
    emTxt = emTxt + "<p>Expected Corrections (if any)" + " </p>";
    emTxt =
      emTxt +
      "<table style='border: 1px solid black; max-width: 450px;min-width:450px'><tbody>";
    emTxt =
      emTxt +
      this.getHtmlRow(
        this.state.data.payload.infoExist1,
        this.state.data.payload.expectedChange1
      );
    emTxt =
      emTxt +
      this.getHtmlRow(
        this.state.data.payload.infoExist2,
        this.state.data.payload.expectedChange2
      );
    emTxt =
      emTxt +
      this.getHtmlRow(
        this.state.data.payload.infoExist3,
        this.state.data.payload.expectedChange3
      );
    emTxt =
      emTxt +
      this.getHtmlRow(
        this.state.data.payload.infoExist4,
        this.state.data.payload.expectedChange4
      );
    emTxt = emTxt + "</tbody></table>";
    emTxt =
      emTxt +
      "<p>I have attached with this email the duly completed application form along with photocopies of following documents:</p>";
    emTxt =
      emTxt +
      "<ul><li>Passport</li><li>Work Permit (Front & Back)</li><li>Proof of payment</li></ul>";
    emTxt =
      emTxt +
      "<p>For any further information please rechout to me at my phone number or email provided above.</p>";
    emTxt = emTxt + "<p></p>";
    emTxt = emTxt + "<p><b>Note:</b></p>";
    emTxt = emTxt + "<p></p>";
    emTxt = emTxt + "<p><ul><li>This is a system generated email.</li>";
    emTxt =
      emTxt +
      "<li>Information provided in this renewal application, is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information.</li>";
    emTxt =
      emTxt +
      "<li>For any further information please contact the applicant directly</li>";
    emTxt =
      emTxt +
      "<li>BCS App only generates the application form and submits an email application to the High Commission to facilitate passport holders and make it very easy and simple to submit passport renewal applications. For any further enquires on the renewal process / acceptance of application, users are responsible to contact Bangladesh High Commission directly.</li><ul>";
    emTxt = emTxt + "</p>";
    emTxt = emTxt + "<p></p>";
    return emTxt;
  };

  genPOStatement = () => {
    //set loader to yes

    let emailParams = {
      from:
        '"BCS Easy Passport Application" helper@brooklynzcommunitysupport.com', // sender address
      to: this.state.data.payload.emailId + ",mrp.bdhc.sg@gmail.com", // list of receivers
      subject:
        "Passport Application [" +
        this.state.data.payload.textName +
        " | " +
        this.state.data.payload.passportNumber +
        " | " +
        this.props.cellPhone +
        "]", // Subject line
      text: this.getEmailText(), // plain text body
      html: this.getEmailHtml() // html body
    };

    //get state updated with calc fields
    Promise.all([
      this.getPOData(),
      this.getTemplateId(),
      this.stateChangeHandler(true, "generatingStatement", false),
      this.stateChangeHandler("", "statementLink", false)
    ]).then(res => {
      //console.log("test test: " + res[1]);

      this.props
        .onGetPoStatementB64(res[0], res[1], emailParams)
        .then(pdfResp => {
          this.saveHandler();
          this.createPassRec();
          let suppNotifyText =
            "New End to End passport form generated by " +
            this.state.data.payload.textName +
            " (" +
            this.state.data.payload.phoneNumber +
            ").";
          this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
          this.stateChangeHandler(false, "generatingStatement", false);
          this.stateChangeHandler("submit", "stage", false);
          this.props.onAddRecord({
            path: "myPassApplication",
            payload: {}
          });
        })
        .catch(err => {
          console.log("Salaaa error: " + err);
          this.stateChangeHandler(false, "generatingStatement", false);
          this.stateChangeHandler("", "b64Text", false);
        });
    });
    //request new statement
    //once req completed show the stop loader and show statement
  };

  checkDateContent = dtText => {
    dtText = dtText.trim();
    if (dtText && dtText !== "" && dtText.length !== 11) {
      return (
        <div style={{ padding: "2px" }}>
          Please enter date in DD MMM YYYY format. For example 01 JAN 2020. It
          should match the date on your passport.
        </div>
      );
    } else {
      if (dtText.length === 11) {
        let dateMom = moment(dtText, "DD MMM YYYY").toString();
        if (dateMom.includes("Invalid")) {
          return (
            <div style={{ padding: "2px" }}>
              Please enter date in DD MMM YYYY format. For example 01 JAN 2020.
              It should match the date on your passport.
            </div>
          );
        }
      }
    }
  };

  getRegFormField = (fieldId, placeholder, caption) => {
    return (
      <div>
        <div
          style={{
            padding: "1px",
            textAlign: "right",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            zIndex: "-9",
            margin: "5px",
            fontSize: "12px"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div
              style={{
                width: "40%",
                lineHeight: "12px",
                textAlign: "left",
                paddingLeft: "5px",
                margin: "auto"
              }}
            >
              {caption}
            </div>
            <div
              style={{
                width: "60%",
                border: "1px solid gainsboro",
                borderRadius: "5px",
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                margin: "2px"
              }}
            >
              <TextField
                value={this.state.data.payload[fieldId]}
                onChange={e => {
                  this.stateChangeHandler(e.value, fieldId, true);
                  if (fieldId === "textNameBangla") {
                    this.getBanglaImage(e.value);
                  }
                }}
                onFocus={() => {
                  this.stateChangeHandler(fieldId, "selectedField", false);
                }}
                onFocusOut={() => {
                  console.log("focus out");
                }}
                fullWidth
                placeholder={placeholder}
              />
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: "12px",
              color: "red"
            }}
          >
            {fieldId.includes("dateOf") &&
              this.checkDateContent(this.state.data.payload[fieldId])}
          </div>
        </div>
        {this.state.selectedField &&
          this.state.selectedField === fieldId &&
          this.state.availableOptions && (
            <div
              style={{
                padding: "5px",
                overflow: "auto",
                border: "1.5px solid white"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderBottom: "1.5px soid white",
                  margin: "-5px",
                  marginBottom: "5px"
                }}
              >
                <div
                  style={{
                    width: "70%",
                    borderBottom: "1.5px solid white",
                    paddingLeft: "5px",
                    textAlign: "left"
                  }}
                >
                  Suggestions:
                </div>
                <div
                  style={{
                    width: "30%",
                    textAlign: "right",
                    borderBottom: "1.5px solid white",
                    paddingRight: "5px"
                  }}
                  onClick={() => {
                    this.stateChangeHandler(undefined, "selectedField", false);
                  }}
                >
                  <icon
                    className="fa fa-close"
                    style={{ color: "red", fontSize: "20px" }}
                  />
                </div>
              </div>
              {this.getSelectionTexts(fieldId)}
            </div>
          )}
      </div>
    );
  };

  getSelectionTexts = fieldId => {
    let dateFields = ["dateOfIssue", "dateOfBirth", "dateOfExpiry"];
    let otherFields = ["textName", "passportNumber"];

    if (otherFields.includes(fieldId)) {
      return this.state.availableOptions.map(optText => {
        return (
          <span
            onClick={() => {
              this.stateChangeHandler(
                this.state.data.payload[fieldId] + " " + optText,
                fieldId,
                true
              );
            }}
            style={{
              margin: "5px",
              border: "1px solid white",
              padding: "5px",
              borderRadius: "5px",
              wordWrap: "normal",
              display: "inline-block",
              lineHeight: "14px"
            }}
          >
            {optText}
          </span>
        );
      });
    } else {
      if (dateFields.includes(fieldId)) {
        console.log("tada " + this.state.availableDateOptions);
        return this.state.availableDateOptions.map(optText => {
          return (
            <span
              onClick={() => {
                this.stateChangeHandler(
                  this.state.data.payload[fieldId] + " " + optText,
                  fieldId,
                  true
                );
              }}
              style={{
                margin: "5px",
                border: "1px solid white",
                padding: "5px",
                borderRadius: "5px",
                wordWrap: "normal",
                display: "inline-block",
                lineHeight: "14px"
              }}
            >
              {optText}
            </span>
          );
        });
      }
    }
  };

  getOptions = awsRes => {
    function hasLowerCase(str) {
      return /[a-z]/.test(str);
    }

    let filtText = [];
    let dateText = [];
    for (let i = 0; i < awsRes.rawData.Blocks.length; i++) {
      let blockObj = awsRes.rawData.Blocks[i];
      if (blockObj.BlockType && blockObj.BlockType === "LINE") {
        let strText = blockObj.Text;
        let confLevel = parseFloat(blockObj.Confidence);
        if (confLevel > 85 && !hasLowerCase(strText)) {
          if (strText.length === 11) {
            let dateCheckStr = moment(strText, "DD MMM YYYY").toString();
            if (!dateCheckStr.includes("Invalid")) {
              dateText.push(
                moment(strText, "DD MMM YYYY")
                  .format("DD MMM YYYY")
                  .toString()
              );
            }
          } else {
            filtText.push(strText);
          }
        }
      }
    }
    this.stateChangeHandler(filtText, "availableOptions", false);
    this.stateChangeHandler(dateText, "availableDateOptions", false);
  };

  getScanResults = () => {
    document.getElementById("uploader").value = "";
    let fullObj = this.props.db.idScanResult;
    this.getOptions(fullObj);
    let textsObj = undefined;
    if (fullObj && fullObj.keyValues) {
      textsObj = fullObj.keyValues;
    }
    if (
      textsObj &&
      textsObj !== undefined &&
      Object.keys(textsObj).length > 0
    ) {
      // return textsArray.map(txtObj => {
      //   return <div>{txtObj.DetectedText}</div>;
      // });
      let txtName = "";
      let ppNumber = "";
      let expiryDate = "";
      let dob = "";
      let issueDate = "";

      for (let key in textsObj) {
        if (key && key.length > 0 && key.toLowerCase().includes("ven name")) {
          txtName = txtName + " " + textsObj[key];
          this.stateChangeHandler(txtName, "txtName", true);
        }
        if (key && key.length > 0 && key.toLowerCase().includes("urname")) {
          txtName = txtName + " " + textsObj[key];
          this.stateChangeHandler(txtName, "txtName", true);
        }
        if (
          key &&
          key.length > 0 &&
          key.toLowerCase().includes("ate of issue")
        ) {
          issueDate = textsObj[key];
          this.stateChangeHandler(issueDate, "dateOfIssue", true);
        }
        if (
          key &&
          key.length > 0 &&
          key.toLowerCase().includes("ate of expiry")
        ) {
          expiryDate = textsObj[key];
          this.stateChangeHandler(expiryDate, "dateOfExpiry", true);
        }
        if (
          key &&
          key.length > 0 &&
          key.toLowerCase().includes("ate of birth")
        ) {
          dob = textsObj[key];
          this.stateChangeHandler(dob, "dateOfBirth", true);
        }
        if (
          key &&
          key.length > 0 &&
          key.toLowerCase().includes("passport n") &&
          !key.toLowerCase().includes("previous")
        ) {
          ppNumber = textsObj[key];
          this.stateChangeHandler(ppNumber, "passportNumber", true);
        }
      }
    } else {
      return (
        <div>
          Unable to detect passport information, please return or key in
          manually
          <div>{JSON.stringify(textsObj)}</div>
        </div>
      );
    }
  };

  idScanTo64 = async evtFiles => {
    this.props.onSetUiFlag("idScanInProgress", true);

    try {
      //console.log("triggering inside uploadImage function");

      const Compress = require("compress.js");
      const compress = new Compress();
      const files = [...evtFiles];
      compress
        .compress(files, {
          size: 0.5, // the max size in MB, defaults to 2MB
          quality: 1, // the quality of the image, max is 1,
          maxWidth: 800, // the max width of the output image, defaults to 1920px
          maxHeight: 800, // the max height of the output image, defaults to 1920px
          resize: true // defaults to true, set false if you do not want to resize the image width and height
        })
        .then(async data => {
          let objContents = {
            fetchQuery:
              "https://4ldlcf9ad4.execute-api.ap-southeast-2.amazonaws.com/dev/ak",
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            message: JSON.stringify({
              imageBase64: data[0].data,
              Filters: {
                RegionsOfInterest: [
                  {
                    BoundingBox: {
                      Height: 0.2,
                      Left: 0.01,
                      Top: 0.7,
                      Width: 1.0
                    }
                  }
                ]
              }
            }),
            path: "idScanResult"
          };

          this.props.onReachApi(objContents).then(res => {
            let suppNotifyText =
              "New passport scanned by " +
              this.state.data.payload.textName +
              " (" +
              this.state.data.payload.phoneNumber +
              ").";
            this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
            this.getScanResults();
          });
        });
    } catch (err) {
      this.props.onSetUiFlag("idScanInProgress", false);
      alert(err);
    }
  };

  saveHandler = () => {
    if (this.props.cellPhone && this.props.cellPhone !== "") {
      let myCellNumber = this.props.cellPhone.replace("+65", "");
      let cloudPath = "myPassDetails/" + myCellNumber;

      let saveObj = {
        phoneNumber: this.props.cellPhone,
        dateOfExpiry: this.state.data.payload.dateOfExpiry
      };

      Promise.all([
        addAudit(this.stateChangeHandler, this.props.cellPhone, true)
        //get new ID
      ]).then(res => {
        //console.log(JSON.stringify(this.state.data.payload));
        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            return snap.ref.set(saveObj);
          })
          .catch(err => {
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => {
            console.log("updated");
          });
      });
    }
  };

  createPassRec = () => {
    let cloudPath = "hCommApps/";
    var passApp = this.props.firebase.db.ref("/" + cloudPath).push();
    passApp
      .set({
        applicationDate: moment().format("DD MMM YYYY"),
        passportNo: this.state.data.payload.passportNumber,
        status: "EMAIL GENERATED",
        name: this.state.data.payload.textName,
        cellPhone: this.props.cellPhone
      })
      .catch(err => {
        console.log(err);
        return console.log("some error: " + err);
      })
      .then(err => {
        //clear the bucket
        this.props.firebase.db
          .ref("/myPassApps" + "/" + this.props.cellPhone + "/" + passApp.key)
          .once("value")
          .then(snap => {
            return snap.ref.set({
              applicationDate: moment().format("DD MMM YYYY"),
              passportNo: this.state.data.payload.passportNumber,
              status: "EMAIL GENERATED",
              name: this.state.data.payload.textName,
              cellPhone: this.props.cellPhone
            });
          })
          .catch(err => {
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => {
            console.log("updated");
          });
      });
  };

  reloadAgain = () => {
    //...this.props.db["myPassDetails"]
    if (!this.state.reloadDone) {
      this.setState(prevState => {
        return {
          ...prevState,
          data: {
            path: "",
            payload: {
              ...prevState.data.payload,
              ...this.props.db["myPassDetails"]
            }
          },
          reloadDone: true
        };
      });
    }
  };

  getBanglaImage = banglaText => {
    let tCtx = document.getElementById("textCanvas").getContext("2d");
    tCtx.canvas.width = tCtx.measureText(banglaText).width;
    tCtx.canvas.height = 25;
    tCtx.font = "12px verdana";

    tCtx.fillText(banglaText, 0, 20);
    let banglaB64Text = tCtx.canvas.toDataURL();
    this.stateChangeHandler(banglaB64Text, "banglaB64Text", true);
    //console.log(imageElem.src);
  };

  validatePayPhoto = () => {
    let allFieldsOK = true;
    if (!this.state.payPhoto || this.state.payPhoto.length === 0) {
      allFieldsOK = false;
    }
    return allFieldsOK;
  };

  validateGenPhotos = () => {
    let allFieldsOK = true;
    let wpFront = !this.state.wpFront || this.state.wpFront.length === 0;
    let wpBack = !this.state.wpBack || this.state.wpBack.length === 0;
    let pPhoto =
      !this.state.passportImages || this.state.passportImages.length === 0;
    let signText = !this.state.sigB64 || this.state.sigB64 === "";
    //console.log("returning: " + allFieldsOK);
    if (wpFront || wpBack || pPhoto || signText) {
      allFieldsOK = false;
    }
    return allFieldsOK;
  };

  validateGeneralInputs = () => {
    let allFieldsOK = true;
    let reqFields = [
      "textName",
      "textNameBangla",
      "phoneNumber",
      "passportNumber",
      "dateOfIssue",
      "dateOfExpiry",
      "placeOfIssue"
    ];
    for (let i = 0; i < reqFields.length; i++) {
      if (
        !this.state.data.payload[reqFields[i]] ||
        this.state.data.payload[reqFields[i]] === ""
      ) {
        //console.log(reqFields[i]);
        allFieldsOK = false;
      }
    }
    //console.log("returning: " + allFieldsOK);
    return allFieldsOK;
  };

  getFormInputStageGeneral = () => {
    return (
      <div>
        <div>
          {this.getNextBack("applyHome", "inputCorrection")}
          <div style={{ margin: "0px", textAlign: "center" }}>
            {!this.props.ui["idScanInProgress"] && (
              <div>
                <label
                  for="uploader"
                  style={{
                    padding: "1px",
                    textAlign: "right",
                    border: "1px solid gainsboro",
                    borderRadius: isMobile ? "5px" : "0px",
                    backgroundColor: "rgb(30, 101, 144)",
                    margin: "5px",
                    padding: "6px",
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px",
                    paddingLeft: "20px",
                    paddingRight: "20px"
                  }}
                >
                  <i className="fa fa-camera"></i> SCAN PASSPORT স্ক্যান
                  পাসপোর্ট
                </label>
              </div>
            )}
            {this.props.ui["idScanInProgress"] && (
              <div
                style={{
                  padding: "10px",
                  textAlign: "center"
                }}
              >
                <div>
                  <LinearProgress
                    indeterminate
                    subtitle="Processing image, please wait as it may take upto a minute..."
                  />
                  {/* <CircleProgress
                  indeterminate
                  subtitle="Processing image, please wait as it may take upto a minute..."
                  labelPositionY="bottom"
                  labelPositionX="center"
                /> */}
                </div>
              </div>
            )}
            {!this.props.ui["idScanInProgress"] &&
              this.state.availableOptions &&
              this.state.availableOptions.length > 0 && (
                <div
                  style={{
                    textAlign: "center",
                    margin: "10px"
                  }}
                >
                  {this.state.availableOptions.length}+ fields extracted from
                  provided passport
                </div>
              )}
            {!this.state.generatingStatement && (
              <div>
                {this.getRegFormField(
                  "textName",
                  "আবেদনকারীর নাম (ইংরেজিতে)",
                  "NAME"
                )}
                {this.getRegFormField(
                  "textNameBangla",
                  "আবেদনকারীর নাম (বাংলায়)",
                  "NAME (BANGLA)"
                )}
                {this.getRegFormField(
                  "emailId",
                  "ইমেইল (যদি থাকে)",
                  "EMAIL ID"
                )}
                {this.getRegFormField(
                  "phoneNumber",
                  "ENTER PHONE NUMBER",
                  "PHONE"
                )}
                {this.getRegFormField(
                  "passportNumber",
                  "পাসপোর্ট নম্বর",
                  "PASSPORT #"
                )}
                {this.getRegFormField(
                  "dateOfIssue",
                  "ইস্যুর তারিখ",
                  "ISSUE DATE"
                )}
                {this.getRegFormField(
                  "dateOfExpiry",
                  "মেয়াদ উত্তীর্ণের তারিখ",
                  "EXPIRY DATE"
                )}
                {this.getRegFormField("dateOfBirth", "জন্মতারিখ", "BIRTH DATE")}
                {this.getRegFormField(
                  "placeOfIssue",
                  "ইস্যুর স্থান",
                  "PLACE OF ISSUE"
                )}

                <input
                  type="file"
                  accept="image/*"
                  id="uploader"
                  onChange={evt => {
                    console.log("clicked");
                    //console.log("triggering main function");
                    event.preventDefault();
                    //console.log(evt.target.result);
                    if (evt.target.files[0]) {
                      this.idScanTo64(evt.target.files);
                    } else {
                      console.log("gotcha");
                    }
                  }}
                  style={{
                    visibility: "hidden",
                    height: "0px"
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  getFormInputStageCorrections = () => {
    return (
      <div>
        <div>
          {this.getNextBack("inputGeneral", "inputPhotos")}
          <div style={{ margin: "0px", textAlign: "center" }}>
            <div
              style={{
                margin: "2px",
                marginTop: "5px"
              }}
            >
              <div>EXPECTED CORRECTION</div>
              <div>পাসপোর্টের কোন তথ্য সংশোধন করতে চাইলে</div>
              <div>Leave empty if no changes required</div>
            </div>

            <div
              style={{
                marginTop: "10px"
              }}
            >
              {this.getRegFormField(
                "infoExist1",
                "বর্তমানে প্রদর্শিত তথ্য",
                "1. EXISTING INFORMATION"
              )}
              <div style={{ margin: "-5px" }}></div>
              {this.getRegFormField(
                "expectedChange1",
                "পরিবর্তন/সংশোধোন",
                "1. EXPECTED CHANGE"
              )}
            </div>
            <div
              style={{
                marginTop: "10px"
              }}
            >
              {this.getRegFormField(
                "infoExist2",
                "বর্তমানে প্রদর্শিত তথ্য",
                "2. EXISTING INFORMATION"
              )}
              <div style={{ margin: "-5px" }}></div>
              {this.getRegFormField(
                "expectedChange2",
                "পরিবর্তন/সংশোধোন",
                "2. EXPECTED CHANGE"
              )}
            </div>
            <div
              style={{
                marginTop: "10px"
              }}
            >
              {this.getRegFormField(
                "infoExist3",
                "বর্তমানে প্রদর্শিত তথ্য",
                "3. EXISTING INFORMATION"
              )}
              <div style={{ margin: "-5px" }}></div>
              {this.getRegFormField(
                "expectedChange3",
                "পরিবর্তন/সংশোধোন",
                "3. EXPECTED CHANGE"
              )}
            </div>
            <div
              style={{
                marginTop: "10px"
              }}
            >
              {this.getRegFormField(
                "infoExist4",
                "বর্তমানে প্রদর্শিত তথ্য",
                "4. EXISTING INFORMATION"
              )}
              <div style={{ margin: "-5px" }}></div>
              {this.getRegFormField(
                "expectedChange4",
                "পরিবর্তন/সংশোধোন",
                "4. EXPECTED CHANGE"
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  getFormInputStageGenPhotos = () => {
    return (
      <div>
        {this.getNextBack("inputCorrection", "inputPayment")}
        <div style={{ margin: "0px", textAlign: "center" }}>
          <SignPad
            title={"SIGN PAD"}
            sigB64={this.state.sigB64}
            fieldName={"sigB64"}
            isPayload={true}
            stateChangeHandler={this.stateChangeHandler}
            disabled={false}
          />
          <PhotoUploadPass
            title1={"PASSPORT PHOTO"}
            title2={"লোড পাসপোর্ট ফটো"}
            images={this.state.passportImages}
            fieldName={"passportImages"}
            isPayload={false}
            stateChangeHandler={this.stateChangeHandler}
            disabled={false}
          />
          <PhotoUploadPass
            title1={"WORK PERMIT PHOTO (FRONT)"}
            title2={"লোড পারমিটের সামনের ফটো"}
            images={this.state.wpFront}
            fieldName={"wpFront"}
            isPayload={false}
            stateChangeHandler={this.stateChangeHandler}
            disabled={false}
          />
          <PhotoUploadPass
            title1={"WORK PERMIT PHOTO (BACK)"}
            title2={"লোড পারমিটের পেছনের ফটো"}
            images={this.state.wpBack}
            fieldName={"wpBack"}
            isPayload={false}
            stateChangeHandler={this.stateChangeHandler}
            disabled={false}
          />
        </div>

        <input
          type="file"
          accept="image/*"
          id="uploader"
          onChange={evt => {
            console.log("clicked");
            //console.log("triggering main function");
            event.preventDefault();
            //console.log(evt.target.result);
            if (evt.target.files[0]) {
              this.idScanTo64(evt.target.files);
            } else {
              console.log("gotcha");
            }
          }}
          style={{
            visibility: "hidden",
            height: "0px"
          }}
        />
      </div>
    );
  };

  getFormInputStagePayment = () => {
    return (
      <div>
        {this.getNextBack("inputPhotos", "review")}
        {this.getGenManualForm()}
        <div
          style={{
            margin: "5px",
            border: "2px solid gainsboro"
          }}
        >
          <div
            style={{
              backgroundColor: "orange",
              padding: "5px",
              fontWeight: "bold",
              margin: "5px"
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "large"
              }}
            >
              OPTION B: Upload the payment record & direct submit from the App
              <br />
              অপশন B: অনলাইনে টাকা পাঠিয়ে রিছিট আপলোড করুন এবং ফরম অনলাইনে জমা
              দিন
            </div>
            <div
              style={{
                fontSize: "medium"
              }}
            >
              <ul>
                <li>
                  Please use internet banking to pay S$155 fee as per the
                  details provided below{" "}
                  <span
                    style={{
                      color: "#a70101",
                      fontWeight: "bolder",
                      fontSize: "14px"
                    }}
                  >
                    (You must enter the text highlihted in red box below under
                    the field "Comments for Recipient" on the internet banking
                    screen. Please see the example screen shot at the bottom for
                    details.):
                  </span>
                  <br /> Take screenshot of the payment record and upload using
                  the upload button below. Tap Next button once upload is
                  completed.
                </li>
                <li>
                  <p>
                    দয়াকরে ইন্টারনেট ব্যাঙ্কিং এর মাধ্যমে S$155 ট্রান্সফার করুন.{" "}
                    <span
                      style={{
                        color: "#a70101",
                        fontWeight: "bolder",
                        fontSize: "14px"
                      }}
                    >
                      ব্যাংক ট্রান্সফার করার সময় নিচের লাল বক্সের লিখাটা
                      ট্রান্সফার কমেন্টে লিখুন, অন্যথায় আপনার পেমেন্ট খুজে পাওয়া
                      যাবেনাI নিচে উদাহরণ স্ক্রিনে দেখে নিন.
                    </span>
                    <br /> দয়াকরে পেমেন্টের স্ক্রিনশট নিয়ে নিচের + UPLOAD বাটনে
                    আপলোড করুন
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div style={{ margin: "5px" }}>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td style={{ backgroundColor: "white" }}>Account Name</td>
                  <td style={{ backgroundColor: "white" }}>
                    High Commission of Bangladesh
                  </td>
                </tr>
                <tr>
                  <td style={{ backgroundColor: "white" }}>Account Number</td>
                  <td style={{ backgroundColor: "white" }}>451-301-564-4</td>
                </tr>
                <tr>
                  <td style={{ backgroundColor: "white" }}>Bank</td>
                  <td style={{ backgroundColor: "white" }}>
                    UOB Limited Singapore
                  </td>
                </tr>
                <tr>
                  <td style={{ backgroundColor: "white" }}>
                    Comments for Recipient / My Initials
                  </td>
                  <td
                    style={{
                      backgroundColor: "white",
                      border: "2px solid red"
                    }}
                  >
                    {this.state.data.payload.passportNumber +
                      "-" +
                      this.state.data.payload.textName.substring(0, 10)}
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <div style={{ margin: "0px", textAlign: "center" }}>
                <PhotoUploadPass
                  title1={"PAYMENT RECIEPT PHOTO"}
                  title2={"ফিস ট্রান্সফার করে থাকলে তার রসিদ এখানে আপলোড করুন"}
                  images={this.state.payPhoto}
                  fieldName={"payPhoto"}
                  isPayload={false}
                  stateChangeHandler={this.stateChangeHandler}
                  disabled={false}
                  nextStage="review"
                  setScroll={this.props.setScroll}
                />
              </div>
            </div>
            <p>
              <div>Example payment screen for POSB Bank</div>
              <div
                style={{
                  textAlign: "center"
                }}
              >
                <div
                  style={{
                    margin: "auto"
                  }}
                >
                  <img
                    src={mrpPmtImage}
                    style={{
                      objectFit: "contain",
                      width: "100%"
                    }}
                  />
                </div>
              </div>
            </p>
            {this.getBdgHighCommInfo()}
          </div>
        </div>
      </div>
    );
  };

  getStatementLink = () => {
    if (this.state.statementLink !== "" && !this.state.genertingStatement) {
      if (isMobile) {
        return (
          <div
            style={{
              marginBottom: "0px",
              padding: "5px",
              textAlign: "center"
            }}
          >
            <div
              style={{
                padding: "1px",
                textAlign: "center",
                border: "1px solid gainsboro",
                borderRadius: isMobile ? "5px" : "0px",
                backgroundColor: "rgb(30, 101, 144)",
                padding: "6px",
                fontWeight: "bold",
                color: "white",
                fontSize: "12px"
              }}
              onClick={() => {
                this.openPdfInAppBrowser();
              }}
            >
              <div>
                <i className="fa fa-print"></i> Open Passport Renewal Form
              </div>
              <div>ফরম ওপেন করুন</div>
            </div>
          </div>
        );
      } else {
        return (
          <div
            style={{
              textAlign: "center",
              margin: "5px"
            }}
          >
            <a href={this.state.statementLink} target="_">
              Open Passport Renewal Form
            </a>
          </div>
        );
      }
    } else {
      <div
        style={{
          textAlign: "center"
        }}
      ></div>;
    }
  };

  generateForm = () => {
    //set loader to yes

    //get state updated with calc fields
    console.log("generating form");
    Promise.all([
      this.getPOData(),
      this.getTemplateId(),
      this.stateChangeHandler(true, "generatingManualPDF", false),
      this.stateChangeHandler("", "statementLink", false)
    ]).then(res => {
      console.log("test test: " + res[1]);

      this.props
        .onGetPoStatement(res[0], res[1])
        .then(pdfResp => {
          console.log("ok " + pdfResp);
          //this.saveHandler();
          // let suppNotifyText =
          //   "New passport form generated by " +
          //   this.state.data.payload.textName +
          //   " (" +
          //   this.state.data.payload.phoneNumber +
          //   ").";
          // this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
          if (pdfResp && pdfResp !== undefined) {
            if (pdfResp.response && pdfResp.response !== "") {
              this.stateChangeHandler(pdfResp.response, "statementLink", false);
            }
          }
          this.stateChangeHandler(false, "generatingManualPDF", false);
        })
        .catch(err => {
          console.log("Salaaa error: " + err);
          this.stateChangeHandler(false, "generatingManualPDF", false);
        });
    });
    //request new statement
    //once req completed show the stop loader and show statement
  };

  getGenManualForm = () => {
    return (
      <p
        style={{
          border: "2px solid gainsboro",
          margin: "5px",
          padding: "5px",
          marginBottom: "10px"
        }}
      >
        <p>
          <div
            style={{
              backgroundColor: "orange",
              padding: "2px",
              fontWeight: "bold"
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "large"
              }}
            >
              OPTION A: Download, Print & Apply in person <br />
              অপশন A: ফরম ডাউনলোড করে প্রিন্ট করে হাইকমিশন অফিসে জমা দেয়া
            </div>
            <div style={{ fontSize: "medium" }}>
              <ul>
                <li>
                  Tap the Generate Form button below to download the completed
                  form নিচের জেনারেট বাটন চেপে তৈরী করা ফরম ডাউনলোকডি করুন.
                </li>
              </ul>
            </div>
          </div>
        </p>
        <div
          style={{
            background: "white",
            margin: "5px",
            borderRadius: "5px",
            padding: "10px"
          }}
        >
          <div>
            <div>
              {!this.state.generatingManualPDF &&
                !this.state.generatingStatement &&
                this.getStatementLink()}
            </div>

            {(!this.state.statementLink || this.state.statementLink === "") && (
              <div
                style={{
                  width: "50%",
                  padding: "1px",
                  textAlign: "center",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "rgb(30, 101, 144)",
                  margin: "auto",
                  padding: "6px",
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "12px"
                }}
                onClick={() => {
                  this.generateForm();
                }}
              >
                <div>
                  <i className="fa fa-print"></i> GENERATE FORM
                </div>
                <div>ফরম তৈরি করুন</div>
              </div>
            )}
          </div>
        </div>
      </p>
    );
  };

  getFormReviewStage = () => {
    return (
      <div
        style={{
          padding: "5px",
          margin: "5px",
          backgroundColor: "white"
        }}
      >
        {!this.state.generatingStatement && (
          <p
            style={{
              backgroundColor: "orange",
              padding: "5px",
              fontWeight: "bold"
            }}
          >
            Please carefully review the following information and press the
            confirm button (দয়াকরে নিচের তথ্যগুলো ভালকরে দেখে নিন, সবকিছু ঠিক
            থাকলে নিচের "কনফার্ম" বাটনে চাপুন।):
          </p>
        )}
        <p>
          <span>
            <div
              style={{
                textAlign: "center",
                width: "100%"
              }}
            >
              <div
                style={{
                  width: "50%",
                  padding: "1px",
                  textAlign: "center",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "green",
                  margin: "auto",
                  padding: "6px",
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "12px"
                }}
                onClick={() => {
                  if (!this.state.generatingStatement) {
                    this.genPOStatement();
                  }
                }}
              >
                <div>
                  <i className="fa fa-check"></i> CONFIRM
                </div>
                <div>কনফার্ম</div>
              </div>
              {this.state.generatingStatement && this.getStatementLoader()}
            </div>
          </span>
          {!this.state.generatingStatement && (
            <span>
              <div
                style={{
                  textAlign: "center",
                  width: "100%"
                }}
              >
                <div
                  style={{
                    width: "50%",
                    padding: "1px",
                    textAlign: "center",
                    border: "1px solid gainsboro",
                    borderRadius: isMobile ? "5px" : "0px",
                    backgroundColor: "red",
                    margin: "auto",
                    padding: "6px",
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px"
                  }}
                  onClick={() => {
                    this.stateChangeHandler("inputGeneral", "stage", false);
                  }}
                >
                  <div>
                    <i className="fa fa-arrow-circle-left"></i> CHANGE
                  </div>
                  <div>পরিবর্তন করুন</div>
                </div>
              </div>
            </span>
          )}
        </p>

        {!this.state.generatingStatement && (
          <div>
            <p>
              <b>Particulars</b>
            </p>
            <table className="table table-bordered table-striped">
              <tbody>
                {this.getRow(
                  "Applicant Name (English)",
                  this.state.data.payload.textName
                )}
                {this.getRow(
                  "Applicant Name (Bangla)",
                  this.state.data.payload.textNameBangla
                )}

                {this.getRow(
                  "Passport No.",
                  this.state.data.payload.passportNumber
                )}

                {this.getRow(
                  "Place of Issue",
                  this.state.data.payload.placeOfIssue
                )}
                {this.getRow(
                  "Date of Expiry",
                  this.state.data.payload.dateOfExpiry
                )}
                {this.getRow(
                  "Date of Issue",
                  this.state.data.payload.dateOfIssue
                )}
                {this.getRow(
                  "Date",
                  moment()
                    .format("DD MMM YYYY")
                    .toString()
                )}
                {this.getRow("Mobile No", this.state.data.payload.phoneNumber)}

                {this.getRow("Email Address", this.state.data.payload.emailId)}
              </tbody>
            </table>
            <p></p>
            <p>
              <b>Expected Corrections (if any)</b>
            </p>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Current Value</th>
                  <th>New Value</th>
                </tr>
              </thead>
              <tbody>
                {this.getRow(
                  this.state.data.payload.infoExist1,
                  this.state.data.payload.expectedChange1
                )}
                {this.getRow(
                  this.state.data.payload.infoExist2,
                  this.state.data.payload.expectedChange2
                )}
                {this.getRow(
                  this.state.data.payload.infoExist3,
                  this.state.data.payload.expectedChange3
                )}
                {this.getRow(
                  this.state.data.payload.infoExist4,
                  this.state.data.payload.expectedChange4
                )}
              </tbody>
            </table>
          </div>
        )}

        <p>
          <b>Note:</b>
        </p>
        <p></p>
        <ul>
          <li>
            BCS App only generates the application form and submits it online
            via email to the Bangladesh High Commission, to facilitate passport
            holders and make it very easy and simple to submit the passport
            renewal applications.
          </li>
          <li>
            For any further enquires on the renewal process / acceptance of
            application, users are responsible to contact the Bangladesh High
            Commission directly (Phone Number: 6255 0075 or email:
            mrp.bdhc.sg@gmail.com).
          </li>
          <li>
            Copy of the application email is also sent to the user's email
            address. Please make sure you have entered a valid email address.
          </li>
          <li>
            Information included in the application form is as per the data
            provided by users, and it is the responsibility of users to ensure
            correct input of all information.
          </li>
        </ul>
      </div>
    );
  };

  getFormSubmitStage = () => {
    return (
      <div>
        <div
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            textAlign: "center",
            marginTop: "10px"
          }}
        >
          <div
            style={{
              margin: "auto",
              border: "5px solid green",
              width: "100px",
              height: "100px",
              borderRadius: "100px",
              lineHeight: "90px",
              verticalAlign: "middle"
            }}
          >
            <icon
              className="fa fa-check fa-3x"
              style={{
                color: "green",
                verticalAlign: "middle"
              }}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            {this.getMyPassportApplications()}
            <div
              style={{
                marginTop: "10px"
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  width: "100%"
                }}
              >
                <div
                  style={{
                    width: "75%",
                    padding: "1px",
                    textAlign: "center",
                    border: "1px solid gainsboro",
                    borderRadius: isMobile ? "5px" : "0px",
                    backgroundColor: "rgb(30, 101, 144)",
                    margin: "auto",
                    padding: "6px",
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px"
                  }}
                  onClick={() => {
                    Promise.all([
                      this.stateChangeHandler("home", "stage", false)
                    ]).then(resp => {
                      this.props.cancelHandler();
                      this.props.setScroll(true);
                    });
                  }}
                >
                  <div>
                    <i className="fa fa-home"></i> RETURN TO BCS HOME
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.getBdgHighCommInfo()}
          <div
            style={{
              marginTop: "12px",
              marginBottom: "12px",
              textAlign: "left",
              fontSize: "14px"
            }}
          >
            <ul>
              <li>
                Your application has been sent to the Bangladesh High
                Commission. BCS only submits online application to High
                Commission. It is responsibility of the applicant to do further
                follow-up with High Comm to ensure application is accepted for
                processing. Please note you might be required to visit the High
                Commission in-person in order for your appliccation to be
                accepted for processing.
              </li>
              <li>
                Please check your mail inbox for email id{" "}
                {this.state.data.payload.emailId} to see copy of the
                application.
              </li>
              <li>
                Please also check spam or junk folder to view the copy of
                application email.
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  getPassAppRows = applications => {
    return applications.map(passApp => {
      return (
        <tr>
          <td>{passApp.passportNo}</td>
          <td>{passApp.applicationDate}</td>
          <td>{passApp.status}</td>
        </tr>
      );
    });
  };

  getMyPassportApplications = () => {
    if (this.props.db["myPassApps"] && this.props.db["myPassApps"].length > 0) {
      return (
        <div
          style={{
            margin: "auto",
            fontSize: "11px"
          }}
        >
          <div
            style={{
              margin: "5px",
              padding: "5px"
            }}
          >
            Your current passport applications:
            <div
              style={{
                border: "1px solid black",
                marginTop: "5px"
              }}
            >
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Psprt No</th>
                    <th>Apply Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {this.getPassAppRows(this.props.db["myPassApps"])}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            margin: "auto"
          }}
        >
          <div
            style={{
              margin: "5px",
              padding: "5px"
            }}
          >
            Your current passport applications:
            <div
              style={{
                border: "1px solid black",
                marginTop: "5px"
              }}
            >
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Psprt No</th>
                    <th>Apply Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={3}>
                      Currently you don't have any previous applications.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    }
  };

  getPportHomePage = () => {
    return (
      <div>
        <div>
          <div>
            <div
              style={{
                marginTop: "10px"
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  width: "100%"
                }}
              >
                <div
                  style={{
                    width: "50%",
                    padding: "1px",
                    textAlign: "center",
                    border: "1px solid gainsboro",
                    borderRadius: isMobile ? "5px" : "0px",
                    backgroundColor: "rgb(30, 101, 144)",
                    margin: "auto",
                    padding: "6px",
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px",
                    minWidth: "300px",
                    maxWidth: "300px"
                  }}
                  onClick={() => {
                    this.stateChangeHandler("applyHome", "stage", false);
                  }}
                >
                  <div>
                    <i className="fa fa-book"></i> NEW APPLICATION FORM
                  </div>
                  <div>দরখাস্তের ফরম</div>
                </div>
              </div>
            </div>
          </div>
          <div></div>
          <div>{this.getMyPassportApplications()}</div>
          <div>{this.getBdgHighCommInfo()}</div>
        </div>
      </div>
    );
  };

  getBdgHighCommInfo = () => {
    return (
      <div
        style={{
          margin: "10px"
        }}
      >
        <div
          style={{
            fontWeight: "bold"
          }}
        >
          BDG HIGH COMM CONTACT:{" "}
        </div>
        <div>
          <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <td>Phone # </td>
                <td>+65-66610295 / 66610290 / 66610280 </td>
              </tr>
              <tr>
                <td>Address</td>
                <td>
                  Bangladesh High Commission, Singapore <br />
                  19 Keppel Road, Jit Poh Building <br />
                  Singapore 089058 # 04-00 <br />
                  (Passport & Visa, Consular and Labour Wing)
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        :
      </div>
    );
  };

  getNextBack = (stageBack, stageNext) => {
    return (
      <div>
        <table
          className="table"
          style={{
            marginBottom: "0px"
          }}
        >
          <tbody>
            <tr>
              <td style={{ border: "0px" }}>
                <div
                  style={{
                    textAlign: "center",
                    width: "100%"
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      padding: "1px",
                      textAlign: "center",
                      border: "1px solid gainsboro",
                      borderRadius: isMobile ? "5px" : "0px",
                      backgroundColor: "rgb(30, 101, 144)",
                      margin: "auto",
                      padding: "6px",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: "12px",
                      minWidth: "140px"
                    }}
                    onClick={() => {
                      this.stateChangeHandler(stageBack, "stage", false);
                    }}
                  >
                    <div>
                      <i className="fa fa-arrow-left"></i> BACK
                    </div>
                  </div>
                </div>
              </td>
              <td style={{ border: "0px" }}>
                <div
                  style={{
                    textAlign: "center",
                    width: "100%"
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      padding: "1px",
                      textAlign: "center",
                      border: "1px solid gainsboro",
                      borderRadius: isMobile ? "5px" : "0px",
                      backgroundColor: "rgb(30, 101, 144)",
                      margin: "auto",
                      padding: "6px",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: "12px",
                      minWidth: "140px"
                    }}
                    onClick={() => {
                      if (stageNext === "inputCorrection") {
                        if (this.validateGeneralInputs()) {
                          this.stateChangeHandler(stageNext, "stage", false);
                        } else {
                          alert("Please complete all fields");
                        }
                      } else if (stageNext === "inputGeneral") {
                        if (
                          !this.state.sgPresence ||
                          this.state.sgPresence === "" ||
                          !this.state.sgDocs ||
                          this.state.sgDocs === ""
                        ) {
                          alert(
                            "Before proceeding next, please answer the questions on screen Yes or No. \n" +
                              ' নেক্সট চাপার পূর্বে স্ক্রিনের দুইটা প্রশ্নের "হা" অথবা "না" সিলেক্ট করুন'
                          );
                        } else if (
                          this.state.sgPresence === "NO" ||
                          this.state.sgDocs === "NO"
                        ) {
                          alert(
                            "To apply for passport renewal/update you must hold \n Passport \n Valid Singapore Visa \n and be present in Singapore."
                          );
                        } else {
                          this.stateChangeHandler(stageNext, "stage", false);
                        }
                      } else if (stageNext === "inputPayment") {
                        if (this.validateGenPhotos()) {
                          this.stateChangeHandler("", "statementLink", false);
                          this.stateChangeHandler(stageNext, "stage", false);
                        } else {
                          alert(
                            "Please sign and upload all the photos \n দয়াকরে সাইন এবং সব ফটো আপলোড করুন"
                          );
                        }
                      } else if (stageNext === "review") {
                        if (this.validatePayPhoto()) {
                          this.stateChangeHandler(stageNext, "stage", false);
                        } else {
                          alert("Please upload photo of payment reciept");
                        }
                      } else {
                        this.stateChangeHandler(stageNext, "stage", false);
                      }
                    }}
                  >
                    <div>
                      NEXT <i className="fa fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  getChoiceButton = (label, stateVal, stateFldId, iconClass, colorIt) => {
    return (
      <div
        style={{
          width: "50%",
          padding: "1px",
          textAlign: "center",
          border: "1px solid gainsboro",
          borderRadius: isMobile ? "5px" : "0px",
          backgroundColor: colorIt ? "rgb(30, 101, 144)" : "white",
          margin: "auto",
          padding: "6px",
          fontWeight: "bold",
          color: colorIt ? "white" : "black",
          fontSize: "12px",
          minWidth: "80px",
          maxWidth: "80px"
        }}
        onClick={() => {
          this.stateChangeHandler(stateVal, stateFldId, false);
        }}
      >
        <div>
          <i className={iconClass}></i> {label}
        </div>
      </div>
    );
  };

  getApplyHomePage = () => {
    return (
      <div>
        {this.getNextBack("home", "inputGeneral")}
        <div
          style={{
            margin: "10px",
            marginTop: "-10px"
          }}
        >
          <div
            style={{
              backgroundColor: "orange",
              padding: "5px",
              fontWeight: "bold",
              marginTop: "5px",
              marginBottom: "5px"
            }}
          >
            Please review/answer following terms and tap on Next button:
          </div>
          <table className="table table-bordered">
            <tbody>
              <tr>
                <td style={{ backgroundColor: "white" }}>
                  Completing passport application can take upto 5 minutes and
                  requires a valid email address and following documents:
                  <ul>
                    <li>Passport</li>
                    <li>Valid Signapore Visa or Work Permit</li>
                  </ul>
                  <p>
                    পাসপোর্টের আবেদন শেষ করতে পাঁচ মিনিটের মতো সময়, নিন্মলিখিত
                    ডকুমেন্টস এবং আপনার ভেলিড ইমেইল এড্রেস লাগবে: <br />
                    1) বর্তমান পাসপোর্টের (2 & 3 পৃষ্ঠার) একটি ক্লিয়ার ফটো{" "}
                    <br /> 2) ভেলিড ওয়ার্ক পার্মিট / স্পেশাল পাস / এমপ্লয়মেন্ট
                    পাস / আই সি-এর (উভয় পৃষ্ঠার) ফটো
                  </p>
                  <p>Do you have these documents?</p>
                  <p>আপনার কাছে কি উপরের ডকুমেন্টস আছে?</p>
                  <p style={{ display: "flex", float: "right" }}>
                    <span>
                      {this.getChoiceButton(
                        "NO",
                        "NO",
                        "sgDocs",
                        "fa fa-cross",
                        this.state.sgDocs === "NO"
                      )}
                    </span>

                    <span>
                      {this.getChoiceButton(
                        "YES",
                        "YES",
                        "sgDocs",
                        "fa fa-tick",
                        this.state.sgDocs === "YES"
                      )}
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ backgroundColor: "white" }}>
                  <p>Are you present in Singapore?</p>
                  <p>আপনি কি বর্তমানে সিঙ্গাপুরে আছেন?</p>

                  <p style={{ display: "flex", float: "right" }}>
                    <span>
                      {this.getChoiceButton(
                        "NO",
                        "NO",
                        "sgPresence",
                        "fa fa-cross",
                        this.state.sgPresence === "NO"
                      )}
                    </span>

                    <span>
                      {this.getChoiceButton(
                        "YES",
                        "YES",
                        "sgPresence",
                        "fa fa-tick",
                        this.state.sgPresence === "YES"
                      )}
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ backgroundColor: "white" }}>
                  The information you provide in application must be correct and
                  up to date; incorrect or false information can lead to delays.
                </td>
              </tr>
              <tr>
                <td style={{ backgroundColor: "white" }}>
                  Based on the current processing times, the passport renewal &
                  updates can take upto 7 to 8 weeks.
                </td>
              </tr>
              <tr>
                <td style={{ backgroundColor: "white" }}>
                  For any other enquiries or information, please call the High
                  Commission of Bangladesh at +65-66610295 / 66610290 / 66610280
                  or visit in person at following address:{" "}
                  <p>
                    Bangladesh High Commission, Singapore <br />
                    19 Keppel Road, Jit Poh Building <br />
                    Singapore 089058 # 04-00 <br />
                    (Passport & Visa, Consular and Labour Wing)
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ backgroundColor: "white" }}>
                  For any BCS App related information or questions please
                  contact at +65 9456 2455.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <canvas
          id="textCanvas"
          style={{ display: "none", border: "0px solid black" }}
        />
        {!this.props.ui["myPassDetails-downloaded"] && (
          <div
            style={{
              margin: "20px",
              textAlign: "center"
            }}
          >
            Loading data...
          </div>
        )}
        {!this.state.generatingStatement &&
          this.state.generatingManualPDF &&
          this.getManualPDFLoader()}
        {!this.state.generatingManualPDF &&
          this.state.generatingStatement &&
          this.getStatementLoader()}
        {!this.state.generatingStatement &&
          !this.state.generatingManualPDF &&
          this.props.ui["myPassDetails-downloaded"] && (
            <div>
              <div>{this.reloadAgain()}</div>
              {this.state.stage === "home" && this.getPportHomePage()}
              {this.state.stage === "applyHome" && this.getApplyHomePage()}
              {this.state.stage === "inputGeneral" &&
                this.getFormInputStageGeneral()}
              {this.state.stage === "inputCorrection" &&
                this.getFormInputStageCorrections()}
              {this.state.stage === "inputPhotos" &&
                this.getFormInputStageGenPhotos()}
              {this.state.stage === "inputPayment" &&
                this.getFormInputStagePayment()}
              {this.state.stage === "review" && this.getFormReviewStage()}
              {this.state.stage === "submit" && this.getFormSubmitStage()}
            </div>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userProfile: state.db.userProfile,
    db: state.db,
    ui: state.ui
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onSetUiFlag: (flagName, flagVal) => dispatch(setUiFlag(flagName, flagVal)),
    onReachApi: async objContents => dispatch(reachApi(objContents)),
    onGetPoStatement: (data, templateId) =>
      dispatch(getStatement(templateId, data)),
    onGetPoStatementB64: (data, templateId, mailParams) =>
      dispatch(getStatementB64(templateId, data, mailParams)),
    onNotifyUsers: (msgBody, arrayOfUsers) =>
      dispatch(notifyUsers(msgBody, arrayOfUsers)),
    onAddRecord: data => dispatch(actionAddArray2Redux(data))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(BgdPassportServiceExt);



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/BgdPassportServiceExt.jsx